import type { FC, PropsWithChildren } from 'react';
import { useRecoilValue } from 'recoil';
import { ServicesContext } from './Context';
import { servicesState } from './store';

export const ServicesProvider: FC<PropsWithChildren<object>> = ({ children }) => {
  const services = useRecoilValue(servicesState);

  return <ServicesContext.Provider value={services}>{children}</ServicesContext.Provider>;
};

ServicesProvider.displayName = 'ServicesProvider';
